<template>
    <commonModal :show.sync="config" isHideFooter :width="800" :styles="{ maxHeight:'600px', overflow: 'auto'}">
      <div class="modal-header" slot="header">{{title}}</div>
      <div v-html="content"></div>
    </commonModal>
</template>

<script>
import commonModal from "components/commonModal/index.vue";
export default {
  name: "ruleModal",
  components:{
    commonModal
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fullscreen: false,
    };
  },
  computed: {
    config: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    cancel() {
      this.config = false;
    },
  },
};
</script>

<style lang="less" scoped>
.modal-header {
  width: 100%;
  position: relative;

  span {
    font-size: 16px;
    line-height: 25px;
  }
  .fullscreen {
    position: absolute;
    right: 30px;
    cursor: pointer;
    color: #888;
    transition: color 0.3s;
    &:hover {
      color: #111;
    }
  }
}
.rule-content-area-height {
  max-height: 400px;
}
// 规则样式
.rule-content-area {
  padding: 25px 30px;
  overflow-y: auto;
  .sub-title {
    margin-bottom: 20px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  p {
    margin-bottom: 20px;
  }
  .p-red {
    color: #fc461e;
  }
  h2 {
    font-size: 18px;
    padding-bottom: 10px;
    margin-bottom: 12px;
    border-bottom: #f1f1f1 dashed 1px;
  }
  i {
    color: #fc461e;
    font-style: normal;
  }
  .tips {
    color: #898989;
    padding-left: 20px;
  }
}
</style>
